import { ResponsiveBar } from '@nivo/bar';
import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    chartContainer: {
        height: '40vh',
        marginBottom: '2rem',
        marginRight: '-60px',
        marginLeft: '0px'
    }
});

const BarChart = ({ data, keys, colors, axisLeftLegend, format, label, legendOffset }) => {
    const styles = useStyles();
    return (
        <div className={styles.chartContainer}>
            <ResponsiveBar
                theme={{
                    tooltip: {
                        container: {
                            fontSize: 12
                        }
                    }
                }}
                data={data}
                keys={keys}
                indexBy={'date'}
                margin={{ right: 60, bottom: 60, left: 60, top: 20 }}
                padding={0.3}
                label={label}
                colors={colors}
                borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                axisTop={null}
                axisRight={null}
                axisBottom={{ tickSize: 5, tickPadding: 5 }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: axisLeftLegend,
                    legendPosition: 'middle',
                    legendOffset: legendOffset,
                    format: format
                }}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{ from: 'color', modifiers: [['brighter', 1.6]] }}
                legends={[
                    {
                        dataFrom: 'keys',
                        anchor: 'bottom',
                        direction: 'column',
                        justify: false,
                        translateX: 160,
                        translateY: 50,
                        itemsSpacing: 2,
                        itemWidth: 100,
                        itemHeight: 20,
                        itemDirection: 'left-to-right',
                        itemOpacity: 1,
                        symbolSize: 20
                    }
                ]}
            />
        </div>
    );
};

export default BarChart;
